import { render, staticRenderFns } from "./pingredientlist.vue?vue&type=template&id=05982662&scoped=true&"
import script from "./pingredientlist.vue?vue&type=script&lang=js&"
export * from "./pingredientlist.vue?vue&type=script&lang=js&"
import style0 from "./pingredientlist.vue?vue&type=style&index=0&id=05982662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05982662",
  null
  
)

export default component.exports